export const tokenConfig = (getState) => {
	const token = getState().auth.accessToken;

	const config = {
		headers: {
			'Content-Type': 'application/json',
		},
	};

	if (token) {
		config.headers['Authorization'] = `Bearer ${token}`;
	}

	return config;
};
